module.exports = __webpack_public_path__ + "static/media/nc-logo-w.ea7b3cd8.svg";